export default "__VITE_ASSET__DQyZXrWn__"